import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { CustomNavBar } from "../../components";
import ApplyRecordPopup from "./components/ApplyRecordPopup";
import EventDetailPopup from "./components/EventDetailPopup";
import EventItem from "./components/EventItem";
import { useGetEventList } from "./hooks/event.hook";
import styles from "./style.module.scss";

function Event() {
  const location = useLocation();
  const [showRecord, setShowRecord] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [nowDetailItem, setNowDetailItem] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();
  const getEventList = useGetEventList({});
  const rightSideRender = (
    <span
      onClick={() => {
        setShowRecord(true);
      }}
      style={{ color: "var(--nav-topbar-text)" }}
    >
      {t("personal.agentList.record")}
    </span>
  );

  return (
    <div className={styles.event}>
      <CustomNavBar
        onBack={() => {
          if (location.pathname.includes("personal")) {
            navigate("/personal");
          } else {
            navigate("/home");
          }
        }}
        right={rightSideRender}
      >
        {t("menu.personal.agentEvent")}
      </CustomNavBar>
      <div className={styles.eventListContainer}>
        {getEventList.data?.length === 0
          ? t("normal.nodata")
          : getEventList.data?.map((item, index) => {
              return (
                <EventItem
                  key={"event" + index}
                  item={item}
                  itemOnClick={() => {
                    setNowDetailItem(item);
                    setShowDetail(true);
                  }}
                />
              );
            })}
      </div>
      <ApplyRecordPopup
        visible={showRecord}
        onClose={() => {
          setShowRecord(false);
        }}
        destroyOnClose={true}
      />
      <EventDetailPopup
        visible={showDetail}
        onClose={() => {
          setShowDetail(false);
          setNowDetailItem({});
        }}
        detailItem={nowDetailItem}
      />
    </div>
  );
}

export default Event;
